import * as React from 'react'
import { renderRichtextChecklist } from '../../lib/utils/renderRichtextChecklist'
import {
  StyledFeaturesAccordion,
  StyledFeaturesAccordionHeadline,
  StyledFeaturesAccordionImages,
  StyledFeaturesAccordionImagesItem,
  StyledFeaturesColumns,
  StyledFeaturesColumnsHeadline,
  StyledFeaturesColumnsItem,
  StyledFeaturesMulticolumnsItem,
  StyledHeadline,
  StyledWrapper,
} from './styled'
import { sbEditable } from '@storyblok/storyblok-editable'

const AccordionHeadline = ({ headline }) => {
  return <StyledFeaturesAccordionHeadline>{headline}</StyledFeaturesAccordionHeadline>
}

const AccordionImages = ({ images }) => {
  return images.length > 0 ? (
    <StyledFeaturesAccordionImages>
      {images &&
        images.map(image => {
          return <StyledFeaturesAccordionImagesItem key={image.id} src={image.filename} alt={image.alt || image.name} />
        })}
    </StyledFeaturesAccordionImages>
  ) : (
    <></>
  )
}

export const FeaturesList = ({ blok: featuresList }) => {
  return (
    <StyledWrapper {...sbEditable(featuresList)}>
      <StyledHeadline>{featuresList.headline}</StyledHeadline>
      {featuresList.accordions.map(accordion => {
        return (
          <StyledFeaturesAccordion
            theme={accordion.colorTheme}
            key={accordion._uid}
            headline={<AccordionHeadline headline={accordion.headline} />}
            headerSub={<AccordionImages images={accordion.images} />}
            isOpen={accordion.accordionOpen}
          >
            {accordion.body.length > 1 ? (
              <StyledFeaturesColumns>
                {accordion.body.map(column => {
                  return (
                    <StyledFeaturesColumnsItem key={column._uid} multiColumn={column.multiColumn}>
                      {column.headline && (
                        <StyledFeaturesColumnsHeadline>{column.headline}</StyledFeaturesColumnsHeadline>
                      )}
                      <div className="prose">{renderRichtextChecklist(column.checkList)}</div>
                    </StyledFeaturesColumnsItem>
                  )
                })}
              </StyledFeaturesColumns>
            ) : (
              <StyledFeaturesMulticolumnsItem
                className="prose"
                style={{ columnCount: accordion.body[0]?.normalFormatting ? 'unset' : undefined }}>
                {renderRichtextChecklist(accordion.body[0].checkList)}
              </StyledFeaturesMulticolumnsItem>
            )}
          </StyledFeaturesAccordion>
        )
      })}
    </StyledWrapper>
  )
}
